import { ODataV4Adaptor, ODataAdaptor, WebApiAdaptor, UrlAdaptor, Query } from '@syncfusion/ej2-data';
import { saveAs } from 'file-saver';
import { DateTime } from 'luxon';
import md5 from 'md5';

import { Buffer } from 'buffer';

import {
    enrollmentIcon,
    emergencyIcon,
    psychIcon,
    inpatientIcon,
    outpatientIcon,
    medicationIcon,
    procedureIcon,
    inboundIcon,
    outboundIcon,
    callIcon,
    gymIcon,
    transportationIcon,
    dentalIcon,
    visionIcon,
    mealIcon,
    teleDoctorIcon,
    blackCardIcon,
    approveIcon,
    denyIcon,
    oopIcon,
    labIcon,
} from '../icons/svgIcons';

export const GapTypes = {
    0: 'STARS',
    1: 'HCC',
    STARS: 'STARS',
    HCC: 'HCC',
};

//Match GapStatus.cs
export const GapStatuses = {
    Open: 'Open',
    PendingReview: 'Pending Review',
    Query: 'Query',
    ResubmittedAwaitingReview: 'Resubmitted-Awaiting Review',
    ReviewedRejected: 'Reviewed-Rejected',
    ReviewedClosed: 'Reviewed-Closed',
    Pended: 'Pended',
    SecondLevelReview: 'Second Level Review',
    Duplicate: 'Duplicate',
    ReviewedCoded: 'Reviewed-Coded',
};

export function gapStatusConvertButtonContent(gapStatus) {
    switch (gapStatus) {
        case 'Open':
        case 0:
            return 'Send';
        case 'Query':
        case 2:
            return 'Re-submit';
        case 'PendingReview':
        case 'InReivew':
        case 'FollowUp':
        case 1:
        case 'ResubmittedAwaitingReview':
        case 3:
        case 'ReviewedRejected':
        case 4:
        case 'ReviewedClosed':
        case 5:
            return 'Update';
        case 'Pended':
        case 6:
            return 'Pended';
        case 'Second Level Review':
        case 'SecondLevelReview':
        case 7:
            return 'Second Level Review';
        default:
            return 'Invalid';
    }
}

export const fileRequestTypes = {
    advancedSearchResultsExcel: 'advancedSearchResultsExcel',
    patientListSearchResultsExcel: 'patientListSearchResultsExcel',
    patientWithOpenGaps_exportExcel: 1,
    upcomingAnnualVisits_exportExcel: 2,
    pastAnnualVisits_exportExcel: 3,
    allPatients_exportExcel: 4,
    gapsInReview_exportExcel: 5,
    supplementalFile_exportExcel: 7,
};

export const filterControlType = {
    MultiSelect: 'MultiSelect',
    TextBox: 'TextBox',
    CheckBox: 'CheckBox',
    NumericTextBox: 'NumericTextBox',
    DatePicker: 'DatePicker',
    DateRangePicker: 'DateRangePicker',
    Selection: 'Selection',
    DateTimePicker: 'DateTimePicker',
    MonthPicker: 'MonthPicker',
    RadioButton: 'RadioButton',
    sectionHeader: 'sectionHeader',
    GoogleAutoComplete: 'GoogleAutoComplete',
    CascadingMultiSelect: 'CascadingMultiSelect',
    AutoComplete: 'AutoComplete',
    ComboBox: 'ComboBox',
};

export const memberDataTypes = {
    allergies: 'allergies',
    audits: 'audits',
    projectedRiskScores: 'projectedRiskScores',
    diagnosis: 'diagnosis',
    clinicalAlerts: 'clinicalAlerts',
    hccAlerts: 'hccAlerts',
    labs: 'labs',
    medications: 'medications',
    procedures: 'procedures',
    visits: 'visits',
    vitals: 'vitals',
    medicalClaims: 'medicalClaims',
    authorizations: 'authorizations',
    eligibility: 'eligibility',
    providerHistory: 'providerHistory',
    advancedSearch: 'advancedSearch',
    singleMemberSearch: 'singleMemberSearch',
    eligibilitySearch: 'eligibilitySearch',
    userManagementUserReport: 'userManagementUserReport',
    claimAuditor: 'claimAuditor',
    myUpcomingVisits: 'myUpcomingVisits',
    myPastVisits: 'myPastVisits',
    myAllVisits: 'myAllVisits',
    generic: 'generic',
};

export const providerDataTypes = {
    allergies: 'allergies',
    audits: 'audits',
    projectedRiskScores: 'projectedRiskScores',
    diagnosis: 'diagnosis',
    clinicalAlerts: 'clinicalAlerts',
    hccAlerts: 'hccAlerts',
    labs: 'labs',
    medications: 'medications',
    procedures: 'procedures',
    visits: 'visits',
    vitals: 'vitals',
    medicalClaims: 'medicalClaims',
    authorizations: 'authorizations',
    eligibility: 'eligibility',
    providerHistory: 'providerHistory',
    advancedSearch: 'advancedSearch',
    singleMemberSearch: 'singleMemberSearch',
    eligibilitySearch: 'eligibilitySearch',
    userManagementUserReport: 'userManagementUserReport',
    claimAuditor: 'claimAuditor',
    myUpcomingVisits: 'myUpcomingVisits',
    myPastVisits: 'myPastVisits',
    myAllVisits: 'myAllVisits',
    generic: 'generic',
};

export const searchTypes = {
    mainSearch: 'mainSearch',
    advancedSearch: 'advancedSearch',
    singleMemberSearch: 'singleMemberSearch',
};

export const eventTypes = {
    default: 'default',
    medication: 'medication',
    procedure: 'procedure',
    communication: 'communication',
    benefit: 'benefit',
    oopDetail: 'oopDetail',
    authorization: 'authorization',
    lab: 'lab',
};

export const moduleIdMap = {
    None: 0,
    DailyCensus: 1,
    ClinicalAlerts: 2,
    HCCAlerts: 3,
    HEDIS: 4,
    Jumpstart: 5,
    AlertWorkflowUtility: 6,
    JSAAdminProviders: 7,
    JSAAdminAssessments: 8,
    JSAReportsPending: 9,
    JSAReportsOutreach: 10,
    JSAReportsCompleteAndInProgress: 11,
    P360PatientViewer: 12,
    CareGapWorklist: 13,
    CareGapAllPatients: 14,
    CareGapDashboards: 15,
    CareGapGuidelines: 16,
    IPADashBoard: 17,
    UserManagementUsers: 18,
    UserManagementGroups: 19,
    UserManagementProviders: 20,
    P360Details: 21,
    ClaimsOutliers: 22,
    UserManagementOrganizations: 23,
    RXClaimOutliers: 24,
    StarDashboard: 25,
    PCPDashboard: 26,
    NCIPADashBoard: 27,
    AVAExpresEligibility: 28,
    AccessExpressWorkLists: 29,
    AccessExpressMessagesEmail: 30,
    AVAExpressEligibilitySpecialist: 31,
    AccessExpressSupport: 32,
    JSAOutreach: 33,
    JSAAssessment: 34,
    JSADashboards: 35,
    Audit: 36,
    CensusDailyCensus: 37,
    CensusDischargeManagement: 38,
    CensusAdmission: 51,
    CensusFrequesntFlyer: 39,
    CensusDashboards: 40,
    DisenrollmentDashboards: 42,
    PatientPriorityGapsReview: 43,
    UserManagementUsersReport: 44,
    ClaimsAuditor: 45,
    AvaCharts: 46,
    QueryManager: 47,
    JSASearch: 48,
    MyQueue: 49,
    DisenrollmentAdvancedSearch: 50,
    Messages: 59,
};

export const endpointNames = {
    Campaign: 'Campaign',
    Case: 'Case',
    Task: 'Task',
    CampaignMember: 'CampaignMember',
};

export const adaptorTypes = {
    ODataV4: 'ODataV4',
    OData: 'OData',
    WebApi: 'WebApi',
    Url: 'Url',
};

export const dynamicQueryTypes = {
    DataManagerQuery: 'DataManagerQuery',
    TraversalGraphQuery: 'TraversalGraphQuery',
    DynamicGraphQuery: 'DynamicGraphQuery',
    CustomGraphQuery: 'CustomGraphQuery',
};

export const adaptorMap = {
    ODataV4: ODataV4Adaptor,
    OData: ODataAdaptor,
    WebApi: WebApiAdaptor,
    Url: UrlAdaptor,
};

export const outreachStatuses = [
    'Successful Contact',
    'Request call back',
    'Left voicemail or message',
    'Busy / Line just rings / No VM',
    'Phone line disconnected',
    'Wrong Number',
    'Other',
];

export const derReasons = [
    'Error - Joined AHP in Error / Return to Previous Plan',
    'Error - Unaware of Disenrollment',
    'Error - Misled by Sales Agent',
    'Part D - Coverage Gap',
    'Part D - Drug Cost/Co-Pay',
    'Part D - Drug Not on Formulary',
    'Part D - Pharmacy',
    'Network - PCP Not Contracted',
    'Network - Quality of PCP/Office',
    'Network - Specialist Not Contracted',
    'Network - Quality of Specialist',
    'Network - Drive Time/Distance',
    'Network - IPA Not Contracted',
    'Network - Hospital Not Contracted',
    'Health Plan Operations - Prior Authorization Process',
    'Health Plan Operations - Customer Service',
    'Prefers Other Benefits/Dissatisfied with - Specialist Copay',
    'Prefers Other Benefits/Dissatisfied with - Hospital/ER Copay',
    'Prefers Other Benefits/Dissatisfied with - Monthly Premium',
    'Prefers Other Benefits/Dissatisfied with - MOOP Limit',
    'Prefers Other Benefits/Dissatisfied with - Part B Reduction',
    'Prefers Other Benefits/Dissatisfied with - OTC',
    'Prefers Other Benefits/Dissatisfied with - Vision',
    'Prefers Other Benefits/Dissatisfied with - Hearing',
    'Prefers Other Benefits/Dissatisfied with - Dental',
    'Prefers Other Benefits/Dissatisfied with - Transportation',
    'Prefers Other Benefits/Dissatisfied with - Fitness/Gym',
    'Prefers Other Benefits/Dissatisfied with - Other',
    'Other - Loss of Part A Medicare Benefit',
    'Other - Loss of Part B Medicare Benefit',
    'Other - Prefers Original FFS Medicare',
    'Other - Prefers Medi-Medi',
    'Other - Employer Requires Sponsored Plan',
    'Other - Long Term Care / Institutionalized',
    'Other - Moved Out of Area',
    'No Reason / Refused / Unable to Obtain',
];

export const newPlanSources = [
    'Sales Agent on Record',
    'New Sales Agent',
    'PCP or Specialist Office',
    'Friend/Family (Not Sales Agent)',
    'Self',
    'Refused / Unable to Obtain',
];

export const disenrollmentStatuses = [
    'Cancelled Enrollment App with Other Health Plan',
    'Re-Enrollment No Gap in Coverage',
    'Re-Enrollment Gap in Coverage',
    'Re-Enrollment Through Medicare',
    'Member will proceed to disenroll',
];

export function getEventIcon(type) {
    switch (type) {
        case 'ENR.':
            return enrollmentIcon;
        case 'ER':
            return emergencyIcon;
        case 'PF':
            return psychIcon;
        case 'IP':
            return inpatientIcon;
        case 'OBS':
            return outpatientIcon;
        case 'RX':
            return medicationIcon;
        case 'PROC':
            return procedureIcon;
        case 'INBOUND':
            return inboundIcon;
        case 'OUTBOUND':
            return outboundIcon;
        case 'CALL':
            return callIcon;
        case 'GYM':
            return gymIcon;
        case 'TRANSPORTATION':
            return transportationIcon;
        case 'DENTAL':
            return dentalIcon;
        case 'VISION':
            return visionIcon;
        case 'BLACKCARD':
            return blackCardIcon;
        case 'MEAL':
            return mealIcon;
        case 'TELEDOCTOR':
            return teleDoctorIcon;
        case 'APPROVED':
            return approveIcon;
        case 'DENIED':
            return denyIcon;
        case 'OOP':
            return oopIcon;
        case 'LAB':
            return labIcon;
        default:
            return enrollmentIcon;
    }
}

export function getFileNameFromResponse(xhr) {
    var filename = '';
    var disposition = xhr.getResponseHeader('Content-Disposition');
    if (disposition && disposition.indexOf('attachment') !== -1) {
        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        var matches = filenameRegex.exec(disposition);
        if (matches !== null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '');
        }
    }
    return filename;
}

export function xMonthsAgo(x) {
    return new Date().setMonth(new Date().getMonth() - x);
}

export const ValidDateConstants = {
    MINYEAR: 1970,
    MAXYEAR: 2100,
};

export function isValidDateObject(date) {
    if (!(date.getTime() === date.getTime())) {
        return false;
    }

    return date.getFullYear() >= ValidDateConstants.MINYEAR && date.getFullYear() <= ValidDateConstants.MAXYEAR;
}

export function isValidDate(dateStr) {
    if (!dateStr) {
        return false;
    }
    const dt = DateTime.fromFormat(dateStr, 'M/d/yyyy');
    return dt.isValid && dt.year >= ValidDateConstants.MINYEAR && dt.year <= ValidDateConstants.MAXYEAR;
}

export function isValidDateRange(dateRangeStr) {
    if (!dateRangeStr) {
        return false;
    }
    let dates = dateRangeStr.split('to');
    if (dates.length !== 2) {
        return false;
    }
    dates = dates.map((date) => date.trim());
    return (
        dates.every((date) => isValidDate(date)) &&
        DateTime.fromFormat(dates[0], 'M/d/yyyy') <= DateTime.fromFormat(dates[1], 'M/d/yyyy')
    );
}

export function formatDate(date, emptyValue = '') {
    if (!date || date.length === 0) return emptyValue;
    const dt = typeof date === 'string' ? DateTime.fromISO(date) : DateTime.fromJSDate(new Date(date));
    return dt.isValid ? dt.toFormat('MM/dd/yyyy') : date;
}

export function formatLuxonDate(date) {
    if (date == null) return null;
    if (date instanceof DateTime) return date;
    if (typeof date == 'string' && date.includes('-')) {
        return DateTime.fromISO(date);
    }
    if (typeof date == 'string' && date.includes('/')) {
        return DateTime.fromFormat(date.substring(0, 10), 'MM/dd/yyyy');
    }
    if (typeof date == 'object') {
        if (date.c) return DateTime.fromObject(date.c);
    }
}

export function formatUTCDate(date, emptyValue = '') {
    if (!date || date.length === 0) return emptyValue;
    const dt = DateTime.fromJSDate(new Date(date)).toUTC().startOf('day');
    return dt.isValid ? dt.toFormat('MM/dd/yyyy') : date;
}

export function formatISODate(date, emptyValue = '') {
    if (!date) return emptyValue;
    const dt = typeof date === 'string' ? DateTime.fromISO(date) : DateTime.fromJSDate(new Date(date));
    return dt.isValid ? dt.toFormat('yyyy-LL-dd') : date;
}

export function formatDateTime(dateTime, includeSeconds) {
    if (!dateTime) return '';
    const dt = typeof dateTime === 'string' ? DateTime.fromISO(dateTime) : DateTime.fromJSDate(new Date(dateTime));
    if (!dt.isValid) {
        return dateTime;
    }
    const adj = dt.millisecond >= 502 ? dt.plus({ seconds: 1 }) : dt;
    return adj.toFormat(includeSeconds ? 'D t' : 'D t');
}

export function formatPSTDateTime(dateTime, includeSeconds) {
    if (!dateTime) return '';
    let dt = DateTime.fromJSDate(new Date(dateTime)).toUTC();
    if (!dt.isValid) {
        return dateTime;
    }
    dt = dt.millisecond >= 502 ? dt.plus({ seconds: 1 }) : dt;
    // Display in PST with same visual separators
    const pst = dt.setZone('America/Los_Angeles');
    return pst.toFormat(includeSeconds ? 'D - T' : 'D - t');
}

export function formatISODateTime(dateTime) {
    if (!dateTime || dateTime.length === 0) return '';

    const dt = parseDate(dateTime);

    return dt.isValid ? dt.toFormat('yyyy-MM-dd HH:mm:ss') : dateTime;
}

export function formatISOLocalDateTime(dateTime) {
    if (!dateTime || dateTime.length === 0) return '';
    const dt = typeof dateTime === 'string' ? DateTime.fromISO(dateTime) : DateTime.fromJSDate(new Date(dateTime));
    return dt.isValid ? dt.toLocal().toFormat('MM/dd/yyyy HH:mm:ss') : dateTime;
}

export function formatAbbreviation(dateTime) {
    if (Date.parse(dateTime) < 0) {
        return '';
    }

    const dateToConvert = DateTime.fromJSDate(new Date(dateTime)).setZone('PST');
    const formatDate = dateToConvert.toFormat('MM/dd/yyyy hh:mm a');
    const formatTZ = dateToConvert.offsetNameShort;
    return `${formatDate} ${formatTZ}`;
}

export function customFormatAbbreviation(dateTime) {
    if (Date.parse(dateTime) < 0) {
        return '';
    }

    const dateToConvert = DateTime.fromJSDate(new Date(dateTime)).setZone('PST');
    const formatDate = dateToConvert.toFormat('LLL dd, yyyy, h:mm a');
    const formatTZ = dateToConvert.offsetNameShort;
    return `${formatDate} ${formatTZ}`;
}

export function saveFileRequestResult(response, xhr) {
    var fileName = getFileNameFromResponse(xhr);
    var fileType = xhr.getResponseHeader('content-type');
    var receivedFileBlob = new Blob([response], { type: fileType });
    saveAs(receivedFileBlob, fileName);
}

/** Open file in a new  tab */
export function openFile(response, xhr) {
    const fileType = xhr.getResponseHeader('content-type');
    const blob = new Blob([response], { type: fileType });
    const blobUrl = URL.createObjectURL(blob);

    const newTab = window.open(blobUrl, '_blank');

    // Some browsers may block pop-ups
    if (!newTab) {
        alert('Please allow pop-ups to view the file.');
    }

    // Release memory after a few seconds
    setTimeout(() => URL.revokeObjectURL(blobUrl), 30_000);
}

/**
 * Add or remove an animation to a button in a grid toolbar
 * @param {ref} [gridRef] - Grid reference (gridRef.current if using useRef hook)
 * @param {HTMLElement} [button] - Button element
 * @param {any} [itemId] - Toolbar item id
 * @param {string} [action] - add / remove
 * @param {string} [animation] - animation name
 */
export const buttonLoadingAnimation = (gridRef, button, toolbarItemId, action, animation) => {
    if (!gridRef) return;

    if (action == 'add') {
        button?.classList.add(animation, 'animatedBtn');
        gridRef.toolbarModule.enableItems([toolbarItemId], false);
    } else {
        button?.classList.remove(animation);
        gridRef.toolbarModule.enableItems([toolbarItemId], true);
    }
};

// These enum values should exactly match the AHC.VNext.Core.JSA.Models.JSAType class.
// If you are changing this file in any way, make sure you do the same changes
// to the JSAType.cs file.
export const jsaTypeParser = {
    FacetoFace: 0,
    ComprehensiveHRA: 1,
    MiniJSA: 2,
    InitialHealthAssessment: 3,
    HealthReassessment: 4,
    COC: 5,
    FullFallEvaluation: 6,
    SocialDeterminants: 7,
    DepressionScreening: 8,
    FunctionalStatusADL: 9,
    ClinicalGaps: 12,
    EnhancedFaceToFace: 13,
    0: 'Face to Face',
    3: 'Initial Health Assessment (I-HRA)',
    4: 'Health Reassessment (R-HRA)',
    12: 'Clinical Gaps',
    13: 'Enhanced Face to Face',
};

export const jsaTypeDescriptionParser = {
    'Face to Face': 0,
    'Comprehensive HRA': 1,
    'Mini JSA': 2,
    'Initial Health Assessment (I-HRA)': 3,
    'Health Reassessment (R-HRA)': 4,
    COC: 5,
    'Full Fall Evaluation': 6,
    'Social Determinants': 7,
    'Depression Screening': 8,
    'Functional Status ADL': 9,
    'Clinical Gaps': 12,
    'Enhanced Face to Face': 13,
};

export const jsaStatusTypes = {
    Started: 0,
    Completed: 1,
    NotStarted: 2,
};

//Conversion for JSA Type to provide space, dash or more details etc.
export const JSATypeEnumToStringConverter = [
    { value: 'FaceToFace', text: 'Face to Face' },
    { value: 'InitialHealthAssessment', text: 'Initial Health Assessment (I-HRA)' },
    { value: 'HealthReassessment', text: 'Health Reassessment (R-HRA)' },
    { value: 'ClinicalGaps', text: 'Clinical Gaps' },
    { value: 'EnhancedFaceToFace', text: 'Enhanced Face to Face' },
];

export const JSATypeEnumToStringConverterWithKeys = [
    { value: 0, text: 'Face to Face' },
    { value: 3, text: 'Initial Health Assessment (I-HRA)' },
    { value: 4, text: 'Health Reassessment (R-HRA)' },
    { value: 12, text: 'Clinical Gaps' },
    { value: 13, text: 'Enhanced Face to Face' },
];

export const jsaStatusConverter = [
    { text: 'Not Started', value: 'NotStarted' },
    { text: 'Completed', value: 'Completed' },
    { text: 'Started', value: 'Started' },
];

export const jsaStatusConverteWithKeys = [
    { text: 'Started', value: 0 },
    { text: 'Completed', value: 1 },
    { text: 'Not Started', value: 2 },
];

export const memberJsaStatusConverter = [
    { text: 'Completed', value: 'Completed' },
    { text: 'Pending', value: 'Pending' },
];

//should match ChartReviewStatus.cs file
export const ChartReviewStatuses = {
    ReadyForValidation: 'ReadyForValidation',
    SplitAndValidated: 'SplitAndValidated',
    ValidatedRejected: 'ValidatedRejected',
    PendingReview: 'PendingReview',
    ReviewRejected: 'ReviewRejected',
    ReviewClosed: 'ReviewClosed',
    Query: 'Query',
    ResubmittedAwaitingReview: 'ResubmittedAwaitingReview',
    SecondLevelReview: 'SecondLevelReview',
    Pended: 'Pended',
    Duplicate: 'Duplicate',
    NonCompliant: 'NonCompliant',
    NoOpenGap: 'NoOpenGap',
    ReUploadNeeded: 'ReUploadNeeded',
};

export function prune(array, modules, i, returnArray) {
    if (i === undefined) return prune(array, modules, 0, []);
    return new Promise((resolve) => {
        if (!array || i === array.length) return resolve(returnArray);
        const obj = Object.assign(array[i]);
        if (array[i].nodeChild) {
            prune(array[i].nodeChild, modules).then((childArray) => {
                if (childArray.length > 0) {
                    obj.nodeChild = childArray;
                    returnArray.push(obj);
                }
                prune(array, modules, ++i, returnArray).then((result) => {
                    return resolve(result);
                });
            });
        } else {
            if (!obj.url || !obj.moduleId || modules[obj.moduleId]) {
                returnArray.push(obj);
            }
            prune(array, modules, ++i, returnArray).then((result) => {
                return resolve(result);
            });
        }
    });
}

function _getSearchKey(id) {
    return id;
}

export function getFilterURLParameterValues(filters, getSearchKey = _getSearchKey) {
    if (!filters) return [];

    const parameters = [];
    for (const id of Object.keys(filters)) {
        const searchKey = getSearchKey(id);
        const value = filters[id];
        if (value !== undefined && value !== null && searchKey.length > 0) {
            if (Array.isArray(value) && value.length > 0) {
                parameters.push(`${searchKey}=${encodeURIComponent(value.join(','))}`);
            } else if (value instanceof Date) {
                parameters.push(`${searchKey}=${encodeURIComponent(formatDate(value))}`);
            } else if (typeof value === 'boolean') {
                parameters.push(`${searchKey}=${value}`);
            } else if (typeof value === 'number') {
                parameters.push(`${searchKey}=${value}`);
            } else if (value.length > 0) {
                parameters.push(`${searchKey}=${encodeURIComponent(value)}`);
            }
        }
    }

    return parameters;
}

export function mapFilterArraysToValues(filters) {
    for (const id of Object.keys(filters)) {
        const value = filters[id];
        if (Array.isArray(value)) {
            if (value.length > 0) {
                const joinedStrings = value.join(',');
                filters[id] = joinedStrings;
            } else {
                delete filters[id];
            }
        }
    }
}

export function getQueryWithParams(filters, getSearchKey = _getSearchKey) {
    if (!filters) return new Query();
    const query = new Query();
    for (var id of Object.keys(filters)) {
        var searchKey = getSearchKey(id);
        var value = filters[id];
        query.addParams(searchKey, value);
    }
    return query;
}

export function getColumnsFromFields(data) {
    const columns = [];
    for (const key in data[0]) {
        const column = {
            field: key,
            type: 'string',
            headerText: key,
            width: Math.max(key.length * 15 + 40, Math.min(400, data[0][key].length * 15)),
        };
        if (Number.isInteger(data[0][key]) && key.includes('Date')) {
            column.type = 'date';
            column.format = 'yMd';
            column.width = Math.max(key.length * 15 + 40, 130);
        } else if (typeof data[0][key] === 'boolean') {
            column.type = 'boolean';
            column.displayAsCheckBox = true;
            column.width = Math.max(key.length * 15 + 40, 50);
        } else if (!isNaN(data[0][key])) {
            column.type = 'number';
            column.width = Math.max(key.length * 15 + 40, data[0][key].toString().length * 15);
        }
        columns.push(column);
    }
    return columns;
}

export function calculateAge(dobTimestamp) {
    return new Date(new Date() - new Date(dobTimestamp)).getFullYear() - 1970;
}

export function getProjectionsFromColumns(columns) {
    return `project(${columns.map((column) => `'${column.field}'`).join(',')}).${columns
        .map((column) => (column.projection ? `by(${column.projection})` : `by('${column.field}')`))
        .join('.')}`;
}

export const isNotFutureDateTimePacific = (date) => {
    if (!date) {
        return true;
    }
    const ISODateTime = formatISODateTime(date);
    const ISOPacificDateTime = pacificDateTimeNowISO();
    if (ISODateTime > ISOPacificDateTime) {
        return false;
    }
    return true;
};

export const isNotFutureDatePacific = (date) => {
    if (!date) {
        return true;
    }
    const ISODate = formatISODate(date);
    const ISOPacificDate = pacificDateTimeNowISO();
    if (ISODate > ISOPacificDate) {
        return false;
    }
    return true;
};

export function pacificTimeNow() {
    return new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' });
}

const PARSE_FORMATS = [
    'yyyy-MM-dd HH:mm:ss.SSS',
    'yyyy/MM/dd hh:mm:ss a',
    'yyyy/MM/dd, HH:mm:ss',
    'yyyy/MM/dd HH:mm:ss',
    'yyyy-MM-dd HH:mm:ss',
    'yyyy-MM-dd',
    'M/d/yyyy, h:mm:ss a',
    'M/d/yyyy h:mm:ss a',
    'MM/dd/yyyy hh:mm:ss a',
    'MM/dd/yyyy HH:mm:ss',
    'MM/dd/yyyy',
];

export const parseDate = (date) => {
    if (!date) {
        return DateTime.invalid('Null or undefined date');
    }

    if (DateTime.isDateTime(date)) {
        return date;
    }

    if (date instanceof Date) {
        return DateTime.fromJSDate(date);
    }

    if (typeof date === 'string') {
        const trimmedDate = date.trim();

        let dt = DateTime.fromISO(trimmedDate);

        if (!dt.isValid) {
            dt = DateTime.fromSQL(trimmedDate);
        }

        // Try each custom format
        for (const format of PARSE_FORMATS) {
            if (dt.isValid) break;
            dt = DateTime.fromFormat(trimmedDate, format);
        }

        return dt;
    }

    if (typeof date === 'number') {
        return DateTime.fromMillis(date);
    }

    return DateTime.invalid('Unsupported date format');
};

/**
 * @param {number} length
 * @param {string} unit
 * @returns {Record<string, number>}
 */
export const getDurationFromUnit = (length, unit) => {
    const normalizedUnit =
        {
            H: 'hours',
            D: 'days',
            M: 'months',
            Y: 'years',
        }[unit?.toUpperCase()] ?? unit;

    return { [normalizedUnit]: length };
};

/**
 * @param {*} dateParam
 * @param {DateTime | null | undefined} [defaultDate=null]
 * @returns {DateTime}
 */
export const getValidDate = (dateParam, defaultDate = null) => {
    const fallbackDate = defaultDate ?? DateTime.now();
    const date = parseDate(dateParam);

    return date.isValid ? date : fallbackDate;
};

export function parseDateWithFormat(date, format = 'MM/dd/yyyy') {
    if (!date) {
        return '';
    }

    date = parseDate(date);

    if (!date.isValid) {
        return '';
    }

    return date.toFormat(format);
}

export const getAgeInYears = (date) => {
    const parsedDate = parseDate(date);
    if (!parsedDate.isValid) {
        return '';
    }
    const abs = Math.abs(parsedDate.diffNow('years').years);
    const years = Math.round(abs);
    return years + (years === 1 ? ' year' : ' years');
};

export const getRelativeTime = (date) => {
    const relativeTime = DateTime.fromJSDate(new Date(date)).toRelative({ style: 'long' });
    return relativeTime ? relativeTime.replace(/ ago$/, '').replace(/^in /, '') : '';
};

/**
 * Parses an incoming date value using `parseDate`, then optionally applies
 * a Luxon output format or timezone.
 *
 * Parameters:
 * - `date`: any supported date input like `Date`, Luxon `DateTime`, ISO string and more.
 * - `format`: Luxon `toFormat` string like `'MM/dd/yyyy hh:mm:ss a'`.
 * - `zone`: Luxon timezone id like `'America/Los_Angeles'`.
 */
export function parseDateWithParams(date, format = '', zone = '') {
    if (!date) {
        return '';
    }

    date = parseDate(date);

    if (!date.isValid) {
        return '';
    }

    if (format.length > 0) {
        return date.toFormat(format);
    }

    if (zone.length > 0) {
        return date.setZone(zone);
    }

    return date;
}

export function pacificDateTimeNowISO() {
    return DateTime.now().setZone('America/Los_Angeles').toISO({ suppressMilliseconds: true });
}

export function getYearAndMonth(monthNum) {
    if (!monthNum) {
        return '';
    }
    const year = parseInt(monthNum / 12);
    const month = monthNum % 12;
    const yearStr = year > 0 ? year + (year > 1 ? 'yrs' : 'yr') : '';
    const monthStr = month + (month > 1 ? 'mos' : 'mo');

    return `${yearStr} ${monthStr}`;
}

export function timestampToLocaleString(stamp) {
    if (isNaN(stamp)) {
        return '';
    }
    return new Date(stamp).toLocaleString('en-US');
}

export const ChartStatus = {
    ReadyForValidation: 'Ready for Validation',
    SplitAndValidated: 'Split - Validated',
    ValidatedRejected: 'Validated - Rejected',
    PendingReview: 'Pending Review',
    ReviewRejected: 'Review Rejected',
    ReviewClosed: 'Review Closed',
    Query: 'Query',
    ResubmittedAwaitingReview: 'Resubmitted - Awaiting Review',
    SecondLevelReview: 'Second Level Review',
    Pended: 'Pended',
    Duplicate: 'Duplicate',
    NonCompliant: 'Non-Compliant',
    NoOpenGap: 'No Open Gap',
    ReUploadNeeded: 'Re-Upload Needed',
};

//Match MemberPbpType.cs
export const MemberPBPType = {
    NonVirtual: 'NonVirtual',
    Virtual: 'Virtual',
    All: 'All',
};

export const modules = {
    Authorizations: 'Authorizations',
    CareManagement: 'CareManagement',
    CareOnDemand: 'CareOnDemand',
    Census: 'Census',
    ClaimsInquiry: 'Claims',
    Coder360: 'Coder360',
    CM360: 'CM360',
    CRM: 'CRM',
    EligibilityAndBenefits: 'Eligibility',
    JSA: 'JSA',
    JSAOutreach: 'JSAOutreach',
    LocalUsers: 'LocalUsers',
    Outreach: 'Outreach',
    PatientViewer: 'PatientViewer',
    PanelManagement: 'PanelManagement',
    PatientPriority: 'PatientPriority',
    ReportsSubmissionort: 'ProviderPortalReportSubmission',
    Telehealth: 'Telehealth',
    UM: 'UM',
    VirtualPCP: 'VirtualPCP',
};

export const getControllerName = (module) => {
    switch (module) {
        case modules.CareManagement:
            return 'CMPatientViewer';
        case modules.Census:
            return 'DailyCensus';
        case modules.CRM:
            return 'crm/myqueue';
        case modules.PatientPriority:
            return 'Worklist';
        case modules.LocalUsers:
            return 'LocalUsers';
        case modules.JSA:
            return 'JSAAssessment';
        case modules.VirtualPCP:
            return 'VirtualAppointments';
        default:
            return module;
    }
};

export const isClinicalModule = (module) => {
    return (
        module == modules.CareManagement ||
        module === modules.CareOnDemand ||
        module === modules.Census ||
        module === modules.Coder360 ||
        module === modules.PanelManagement ||
        module === modules.PatientViewer ||
        module === modules.PatientPriority ||
        module === modules.LocalUsers ||
        module === modules.JSA ||
        module === modules.UM
    );
};

export function guidelinesData(moduleId) {
    switch (moduleId) {
        case 'Eligibility':
            return {
                id: 'AVAEligibilityandBenefitsUserGuidepdfContainer',
                fileName: '/AVA_Eligibility_and_Benefits_User_Guide.pdf',
                title: 'AVA Eligibility and Benefits User Guide',
            };
        case 'Authorizations':
            return {
                id: 'AVAAuthorizationUserGuidepdfContainer',
                fileName: '/AVA_Authorization_User_Guide.pdf',
                title: 'AVA Authorizations User Guide',
            };
        case 'Claims':
            return {
                id: 'AVAClaimsUserGuidepdfContainer',
                fileName: '/AVA_Claims_User_Guide.pdf',
                title: 'AVA Claims User Guide',
            };
        case 'LocalUsers':
            return {
                id: 'AVALocalUsersUserGuidepdfContainer',
                fileName: '/Local_AVA_Portal_Administrator_UserGuide_and_FAQs_v1.0_11_03_2025.pdf',
                title: 'AVA Provider Local Administration User Guide & FAQs',
            };
        case 'ProviderPortalReportSubmission':
            return {
                id: 'AVAReportsSubmissionUserGuidepdfContainer',
                fileName: '/AVA_Reports_Submission_User_Guide.pdf',
                title: 'AVA Reports Submission User Guide',
            };
    }
}

function isDateInFutureOrThisMonth(date) {
    if (date) {
        const dateTime = new Date(date);
        const currentDateTime = new Date();
        const timeDiff = dateTime.getTime() - currentDateTime.getTime();
        const timeDiffInDays = timeDiff / (1000 * 60 * 60 * 24);
        if (timeDiffInDays >= -31) return true;
    }
    return false;
}

export function getClassNameForMemberCardHeader(member) {
    if (member == null) {
        return '';
    }
    if (
        (member.memberisActive == false || member.isActive == '0') &&
        !isDateInFutureOrThisMonth(member.effectiveDateTime)
    ) {
        return 'inactive';
    }
    if (member.termDate) {
        return 'term-date';
    }
    if (member.isFrequentCaller == 'Yes') {
        return 'frequent-caller';
    }
    if (isDateInFutureOrThisMonth(member.effectiveDateTime)) {
        return 'new-member';
    }
}

export const getBase64HashFromFile = async (file) => {
    try {
        const arrayBuffer = await file.arrayBuffer();
        const buffer = Buffer.from(arrayBuffer);
        const hash64 = new md5().update(buffer).digest('base64');
        return hash64;
    } catch {
        return null;
    }
};

export const calculateTextBoxHeight = (text, lineHeight = 1.5, baseHeight = 50) => {
    const lineCount = text.split('\n').length || 1;
    const heightPerLine = parseFloat(getComputedStyle(document.body).fontSize) * lineHeight;
    return Math.max(baseHeight, heightPerLine * lineCount);
};

export const DAMAGED_FILE_MESSAGE = 'This file is suspected to be damaged, please verify before upload';

export const isPdfDamaged = async (rawFile) => {
    if (!rawFile) {
        return true;
    }
    const terminationFile = await rawFile.slice(rawFile.size - 8, rawFile.size, rawFile.type).text();
    return terminationFile.indexOf('%%EOF') < 0;
};

export const states = [
    { text: 'California', value: 'CA' },
    { text: 'North Carolina', value: 'NC' },
    { text: 'Texas', value: 'TX' },
    { text: 'Florida', value: 'FL' },
    { text: 'Arizona', value: 'AZ' },
    { text: 'Nevada', value: 'NV' },
];
